import { RatingLevel } from '@core/interview-results-types';
import type { Theme } from '@core/theme-util';
import type { IconName, IconToken } from '@core/user-interface-legacy';

export type RatingThumbLevel = RatingLevel | 'strong_no';

export interface RatingThumbOption {
  level: RatingThumbLevel;
  icon: IconName;
  color: IconToken;
  chartColor: keyof Theme;
  translationKey: string;
}

export const STRONG_NO_THUMB_OPTION: RatingThumbOption = {
  level: 'strong_no',
  icon: 'rating-double-thumb-down',
  color: 'colorIconCriticalStrongDefault',
  chartColor: 'colorIconCriticalDefault',
  translationKey: 'rtu.interview.summary.strong_no',
};

export const RATING_THUMB_OPTIONS: Record<RatingLevel, RatingThumbOption> = {
  [RatingLevel.No]: {
    level: RatingLevel.No,
    icon: 'rating-thumb-down',
    color: 'colorIconCriticalDefault',
    chartColor: 'colorBgCriticalDisabled',
    translationKey: 'rtu.interview.summary.no',
  },
  [RatingLevel.Neutral]: {
    level: RatingLevel.Neutral,
    icon: 'rating-thumbs-up-down',
    color: 'colorIconWarningDefault',
    chartColor: 'colorBgWarningDisabled',
    translationKey: 'rtu.interview.summary.neutral',
  },
  [RatingLevel.Yes]: {
    level: RatingLevel.Yes,
    icon: 'rating-thumb-up',
    color: 'colorIconSuccessDefault',
    chartColor: 'colorBgSuccessDisabled',
    translationKey: 'rtu.interview.summary.yes',
  },
  [RatingLevel.StrongYes]: {
    level: RatingLevel.StrongYes,
    icon: 'rating-double-thumb-up',
    color: 'colorIconSuccessStrongDefault',
    chartColor: 'colorIconSuccessDefault',
    translationKey: 'rtu.interview.summary.strong_yes',
  },
};

export const THUMBS_4_OPTIONS: RatingThumbOption[] = [
  RATING_THUMB_OPTIONS[RatingLevel.No],
  RATING_THUMB_OPTIONS[RatingLevel.Neutral],
  RATING_THUMB_OPTIONS[RatingLevel.Yes],
  RATING_THUMB_OPTIONS[RatingLevel.StrongYes],
];

export const THUMBS_5_OPTIONS: RatingThumbOption[] = [STRONG_NO_THUMB_OPTION, ...THUMBS_4_OPTIONS];
